import { createContext, useContext } from "react";

/**
 * Shared sync-status context. Shell fetches via useSyncStatus() and provides
 * the result here so descendants (Account page, Sidebar's BusinessCard) read
 * the same state. A refetch from the Account page (after clicking "Sync")
 * immediately propagates to the sidebar's timestamps — single source of truth.
 */
export const SyncStatusContext = createContext({
  sources: null,
  recentLogs: null,
  // Gates the Account page's "Seed demo" button. False by default — the server
  // enforces the same restriction and is the authority, but a context default
  // that showed the button would put it in front of every client on any
  // provider mishap.
  demoSeedingAllowed: false,
  loading: false,
  error: null,
  refetch: () => {},
});

export function useSyncStatusContext() {
  return useContext(SyncStatusContext);
}
